module.exports = __webpack_public_path__ + "static/media/README.c68ff32a.md";